import React from "react";
import { Layout } from "../Layout";
import SEO from "../SEO";
import AllClientsList from "../Shared/AllClients";
import { Breadcrumb } from "../Shared/Breadcrumb";
import TopClients from "../Shared/TopClients";
import { FrequentlyAskedQuestions } from "../Shared/Ui/FAQs";
import DedicatedHireServices from "./dedicated-hire-service";
import GetStarted from "./get-started";
import HowToHire from "./how-to";
import HireDedicatedDevelopersServices from "./services";
import Testimonials from "./testimonials";
import HireDedicatedDevelopersWhyHire from "./why-hire";

export default class HireDedicatedDevelopers extends React.Component<any> {
  render(): JSX.Element {
    const {
      seo,
      whyHireTitle,
      whyHireCards,
      testimonialTitle,
      testimonials,
      contentSectionTop,
      contentSectionBottom,
      list,
      footerContent,
      faQs,
    } = this.props;

    return (
      <Layout footerContent={footerContent?.raw}>
        <SEO
          contentfulSeo={seo}
          breadcrumbRoutes={[
            { name: "Home", path: "/" },
            { name: "Hire Dedicated Developers", path: "/hire-dedicated-developer/" },
            { name: seo.metaTitle, path: seo.metaUrl },
          ]}
        />
        <Breadcrumb
          currentPageTitle="Hire Dedicated Developers in India"
          routes={[
            { path: "/", title: "Home" },
            { path: "/hire-dedicated-developer/", title: "Hire Dedicated Developers" },
          ]}
        />

        <div id="dedicated-developers">
          <TopClients />
          <HireDedicatedDevelopersWhyHire cards={whyHireCards} title={whyHireTitle} />
          <HireDedicatedDevelopersServices data={contentSectionTop} />
          <Testimonials list={testimonials} title={testimonialTitle} />
          <HowToHire />
          <HireDedicatedDevelopersServices data={contentSectionBottom} />
          <GetStarted />
          <DedicatedHireServices data={list} />
          <AllClientsList />
        </div>

        {faQs?.length ? <FrequentlyAskedQuestions faQs={faQs} /> : null}
      </Layout>
    );
  }
}
